module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel md-scrollbar md-theme-default",
    attrs: {
      "id": "freights"
    }
  }, [_c('div', {
    staticClass: "md-layout heading"
  }), _c('md-content', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: ({
        id: 'get-freight-list',
        value: _vm.progress
      }),
      expression: "{id: 'get-freight-list', value: progress}"
    }],
    staticClass: "md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('stock-menu'), _c('div', {
    staticClass: "md-flex no-select",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('sort-table', {
    ref: "table",
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.freightAmount,
      "expandable": "expandable",
      "table-id": "freights"
    },
    on: {
      "expand": _vm.onExpand,
      "refresh": _vm.getFreights
    },
    scopedSlots: _vm._u([{
      key: "select",
      fn: function(scope) {
        return [_c('md-checkbox', {
          attrs: {
            "value": scope.item.id
          },
          model: {
            value: (_vm.selectedFreights),
            callback: function($$v) {
              _vm.selectedFreights = $$v
            },
            expression: "selectedFreights"
          }
        })]
      }
    }, {
      key: "status",
      fn: function(scope) {
        return [(scope.item.status) ? _c('span', {
          style: ('color: ' + scope.item.status.color)
        }, [_vm._v(_vm._s(scope.item.status.name))]) : _vm._e(), (!scope.item || !scope.item.status) ? _c('span', [_vm._v("Не установлен")]) : _vm._e()]
      }
    }, {
      key: "actions",
      fn: function(scope) {
        return [_c('span', [(scope.item.deal_id) ? _c('md-button', {
          staticClass: "md-icon-button md-dense",
          attrs: {
            "to": {
              name: 'DealEdit',
              params: {
                dealid: scope.item.deal_id
              }
            }
          }
        }, [_c('md-icon', [_vm._v("content_paste")])], 1) : _vm._e(), _c('md-tooltip', {
          attrs: {
            "md-direction": "top"
          }
        }, [_vm._v("К заявке")])], 1)]
      }
    }, {
      key: "deal_id",
      fn: function(scope) {
        return [(scope.item.deal && scope.item.deal.traking_number) ? _c('span', [_vm._v(_vm._s(scope.item.deal.traking_number))]) : _vm._e(), (!scope.item.deal || !scope.item.deal.traking_number) ? _c('span', [_vm._v("Не установлен")]) : _vm._e()]
      }
    }, {
      key: "from",
      fn: function(scope) {
        return [(scope.item.deal && scope.item.deal.from_address && scope.item.deal.from_address.address) ? _c('span', [_c('span', [_vm._v(_vm._s(scope.item.deal.from_address.address))])]) : _c('span', [(scope.item.deal && scope.item.deal.from_stock && scope.item.deal.from_stock.name) ? _c('span', [_vm._v(_vm._s(scope.item.deal.from_stock.name))]) : _c('span', [_c('b', [_vm._v("Склад/Адрес не установлен")])])])]
      }
    }, {
      key: "to",
      fn: function(scope) {
        return [(scope.item.deal && scope.item.deal.to_address && scope.item.deal.to_address.address) ? _c('span', [_vm._v(_vm._s(scope.item.deal.to_address.address))]) : _c('span', [(scope.item.deal && scope.item.deal.to_stock && scope.item.deal.to_stock.name) ? _c('span', [_vm._v(_vm._s(scope.item.deal.to_stock.name))]) : _c('span', [_c('b', [_vm._v("Склад/Адрес не установлен")])])])]
      }
    }, {
      key: "expanded",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "tracking-container md-layout md-gutter"
        }, [_c('div', {
          staticClass: "timeline-container md-layout-item md-size-33"
        }, [_c('div', {
          staticClass: "timeline"
        }, _vm._l((scope.item.tracking), function(tracking) {
          return _c('div', {
            staticClass: "timeline-row"
          }, [_c('div', {
            staticClass: "date-time"
          }, [_c('div', {
            staticClass: "date"
          }, [_vm._v(_vm._s(_vm.moment(tracking.date).format('DD.MM.YYYY')))]), _c('div', {
            staticClass: "time"
          }, [_vm._v(_vm._s(_vm.moment(tracking.date).format('HH:mm')))])]), _c('div', {
            staticClass: "dot-container"
          }, [_c('div', {
            staticClass: "dot"
          }), _c('div', {
            staticClass: "dot-line"
          })]), _c('div', {
            staticClass: "timeline-content"
          }, [(tracking.status) ? _c('div', {
            staticClass: "status"
          }, [_c('div', {
            staticClass: "text"
          }, [_vm._v(_vm._s(tracking.status.name))])]) : _vm._e(), _c('div', {
            staticClass: "timeline-text-content"
          }, [(tracking.stock) ? _c('div', {
            staticClass: "stock"
          }, [_vm._v("Склад: " + _vm._s(tracking.stock.name))]) : _vm._e(), (tracking.responsible) ? _c('div', {
            staticClass: "responsible"
          }, [_vm._v("Ответственный: " + _vm._s(tracking.responsible.login))]) : _vm._e()])])])
        })), _c('md-button', {
          staticClass: "md-dense small",
          on: {
            "click": function($event) {
              _vm.addTracking(scope.item.id)
            }
          }
        }, [_vm._v("Добавить отметку")])], 1), _c('div', {
          staticClass: "freight-info md-layout-item md-size-33"
        }, [_c('div', {
          staticClass: "content"
        }, [_c('h4', [_vm._v(" Данные груза")]), _c('display-value', {
          attrs: {
            "inline": true,
            "value": (scope.item.traking_number),
            "label": 'Номер отслеживания'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": ((scope.item.status_id) ? scope.item.status.name : 'Не установлен'),
            "label": 'Статус'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": (scope.item.weight + ' кг.'),
            "label": 'Вес'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": (scope.item.size + ' ' + scope.item.size_units + '.'),
            "label": 'Объём'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": ((scope.item.doom) ? 'Да' : 'Нет'),
            "label": 'Обрешётка'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": (scope.item.price + ' руб.'),
            "label": 'Цена'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": ((scope.item.factory_package) ? 'Да' : 'Нет'),
            "label": 'Заводская упаковка'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": ((scope.item.oversized) ? 'Да' : 'Нет'),
            "label": 'Негабаритный груз'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": ((scope.item.seats_number) ? scope.item.seats_number : 'Не установленно'),
            "label": 'Количество мест'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": ((scope.item.forwarder_id) ? scope.item.forwarder.login : 'Не установлен'),
            "label": 'Ответственный экспедитор'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": ((scope.item.description) ? scope.item.description : 'Не установленно'),
            "label": 'Описание'
          }
        }), _c('br'), (scope.item.services && scope.item.services.length) ? _c('h4', [_vm._v(" Дополнительные услуги")]) : _vm._e(), (scope.item.services && scope.item.services.length) ? _c('div', _vm._l((scope.item.services), function(item, i) {
          return _c('display-value', {
            key: i,
            attrs: {
              "inline": true,
              "value": (['select', 'radio'].indexOf(item.service.type) + 1) ? item.name : 'Да',
              "label": item.service.name
            }
          })
        })) : _vm._e()], 1)]), _c('div', {
          directives: [{
            name: "loader-overlay",
            rawName: "v-loader-overlay.sync",
            value: ({
              value: (!scope.item.deal_expand || !scope.item.deal_expand.id),
              id: scope.item.id
            }),
            expression: "{value: (!scope.item.deal_expand || !scope.item.deal_expand.id), id: scope.item.id}",
            modifiers: {
              "sync": true
            }
          }],
          staticClass: "deal-info md-layout-item md-size-33"
        }, [_c('div', {
          staticClass: "content"
        }, [_c('div', {
          staticClass: "info-header"
        }, [_c('h4', [_vm._v(" Данные заявки")]), _c('router-link', {
          attrs: {
            "to": {
              name: 'DealEdit',
              params: {
                dealid: scope.item.deal_id
              }
            }
          }
        }, [_vm._v("Перейти к заявке")])], 1), (scope.item && scope.item.deal_expand) ? _c('div', [_c('display-value', {
          attrs: {
            "value": (scope.item.deal_expand.traking_number) ? scope.item.deal_expand.traking_number : 'Не установлен',
            "label": 'Номер отслеживания'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": (scope.item.deal_expand.status_id) ? scope.item.deal_expand.status.name : 'Не установлен',
            "label": 'Статус'
          }
        }), _c('display-value', {
          attrs: {
            "value": (scope.item.deal_expand.forwarding_date_from) ? _vm.moment(scope.item.deal_expand.forwarding_date_from).format('Do MMMM YYYY (DD.MM.YYYY)') : 'Не установленна',
            "label": 'Планируемая дата экспедирования в пункте отправления'
          }
        }), _c('display-value', {
          attrs: {
            "value": (scope.item.deal_expand.forwarding_date_to) ? _vm.moment(scope.item.deal_expand.forwarding_date_to).format('Do MMMM YYYY (DD.MM.YYYY)') : 'Не установленна',
            "label": 'Планируемая дата экспедирования в пункте назначения'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": scope.item.deal_expand.price + ' руб.',
            "label": 'Цена'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": (scope.item.deal_expand.from_stock_id) ? scope.item.deal_expand.from_stock.name : 'Не установлен',
            "label": 'Склад отправления'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": (scope.item.deal_expand.to_stock) ? scope.item.deal_expand.to_stock.name : 'Не установлен',
            "label": 'Склад назначения'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": (scope.item.deal_expand.from_address_id) ? scope.item.deal_expand.from_address.address : 'Не установлен',
            "label": 'Адрес отпправления'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": (scope.item.deal_expand.to_address_id) ? scope.item.deal_expand.to_address.address : 'Не установлен',
            "label": 'Адрес назначения'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": (scope.item.deal_expand.forwarder_from_id) ? scope.item.deal_expand.forwarder_from.login : 'Не установлен',
            "label": 'Экспедитор в пункте отправления'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": (scope.item.deal_expand.forwarder_to_id) ? scope.item.deal_expand.forwarder_to.login : 'Не установлен',
            "label": 'Экспедитор в пункте назначения'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": (scope.item.deal_expand.responsible_id) ? scope.item.deal_expand.responsible.login : 'Не установлен',
            "label": 'Ответственный менеджер'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": (scope.item.deal_expand.sender_id) ? scope.item.deal_expand.sender.name : 'Не установлен',
            "label": 'Отправитель'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": (scope.item.deal_expand.recipient_id) ? scope.item.deal_expand.recipient.name : 'Не установлен',
            "label": 'Получатель'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": (scope.item.deal_expand.applicant_id) ? scope.item.deal_expand.applicant.name : 'Не установлен',
            "label": 'Заявитель'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": (scope.item.deal_expand.payer_id) ? scope.item.deal_expand.payer.name : 'Не установлен',
            "label": 'Плательщик'
          }
        }), _c('display-value', {
          attrs: {
            "inline": true,
            "value": (scope.item.deal_expand.executor_company_id) ? scope.item.deal_expand.executor.name : 'Не установлен',
            "label": 'Перевозчик'
          }
        })], 1) : _vm._e()])])])]
      }
    }]),
    model: {
      value: (_vm.allFreights),
      callback: function($$v) {
        _vm.allFreights = $$v
      },
      expression: "allFreights"
    }
  })], 1)], 1), _c('md-dialog', {
    attrs: {
      "id": "tracking-form",
      "md-active": _vm.showTrackingForm
    },
    on: {
      "update:mdActive": function($event) {
        _vm.showTrackingForm = $event
      }
    }
  }, [_c('md-field', [_c('label', {
    attrs: {
      "for": "status_id"
    }
  }, [_vm._v("Статус")]), _c('md-select', {
    attrs: {
      "name": "status_id",
      "id": "status_id"
    },
    model: {
      value: (_vm.editedTracking.status_id),
      callback: function($$v) {
        _vm.$set(_vm.editedTracking, "status_id", $$v)
      },
      expression: "editedTracking.status_id"
    }
  }, _vm._l((_vm.statuses), function(status) {
    return _c('md-option', {
      key: status.id,
      attrs: {
        "value": status.id
      }
    }, [_vm._v(_vm._s(status.name))])
  }))], 1), _c('md-field', [_c('label', {
    attrs: {
      "for": "stock_id"
    }
  }, [_vm._v("Склад")]), _c('md-select', {
    attrs: {
      "name": "stock_id",
      "id": "stock_id"
    },
    model: {
      value: (_vm.editedTracking.stock_id),
      callback: function($$v) {
        _vm.$set(_vm.editedTracking, "stock_id", $$v)
      },
      expression: "editedTracking.stock_id"
    }
  }, _vm._l((_vm.stocks), function(stock) {
    return _c('md-option', {
      key: stock.id,
      attrs: {
        "value": stock.id
      }
    }, [_vm._v(_vm._s(stock.name))])
  }))], 1), _c('md-field', [_c('label', {
    attrs: {
      "for": "responsible_id"
    }
  }, [_vm._v("Ответственный")]), _c('md-select', {
    attrs: {
      "name": "responsible_id",
      "id": "responsible_id"
    },
    model: {
      value: (_vm.editedTracking.responsible_id),
      callback: function($$v) {
        _vm.$set(_vm.editedTracking, "responsible_id", $$v)
      },
      expression: "editedTracking.responsible_id"
    }
  }, _vm._l((_vm.usersOfStock), function(user) {
    return _c('md-option', {
      key: user.pivot.user_id,
      attrs: {
        "value": user.pivot.user_id
      }
    }, [_vm._v(_vm._s(user.login))])
  }))], 1), _c('md-field', {
    class: {
      'md-invalid': _vm.errors.has('date'),
      'md-has-value': _vm.editedTracking.date
    }
  }, [_c('label', [_vm._v("Дата")]), _c('datetime', {
    attrs: {
      "input-class": "md-input",
      "type": "datetime",
      "use12-hour": false,
      "week-start": 1,
      "phrases": {
        ok: 'Ок',
        cancel: 'Отмена'
      }
    },
    model: {
      value: (_vm.editedTracking.date),
      callback: function($$v) {
        _vm.$set(_vm.editedTracking, "date", $$v)
      },
      expression: "editedTracking.date"
    }
  }), _c('md-button', {
    staticClass: "md-icon-button md-dense",
    on: {
      "click": function($event) {
        _vm.editedTracking.date = ''
      }
    }
  }, [_c('md-icon', [_vm._v("close")])], 1), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('date')),
      expression: "errors.has('date')"
    }],
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.first('date')))])], 1), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-accent",
    on: {
      "click": function($event) {
        _vm.showTrackingForm = false
      }
    }
  }, [_vm._v("Отмена")]), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.saveTracking
    }
  }, [_vm._v("Сохранить")])], 1)], 1), _c('md-dialog', {
    attrs: {
      "md-active": _vm.deleteDialog,
      "md-theme": "white"
    },
    on: {
      "update:mdActive": function($event) {
        _vm.deleteDialog = $event
      }
    }
  }, [_c('md-dialog-title', [_vm._v("Удалить трекинговую отметку?")]), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("Отмена")]), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.deleteTracking(_vm.trackingToDelete)
      }
    }
  }, [_vm._v("Удалить")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-745c8f0a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/stock/views/Freight.vue
// module id = 1195
// module chunks = 0